import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
  Paper,
  Button,
  FormHelperText,
  FormControl,
  Box,
  Typography,
  Container,
  Grid,
  autocompleteClasses
} from '@mui/material';
import { DialogoMensagem, Select, TextField } from '../../components';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  useNavigate,
} from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useStoreActions } from 'easy-peasy';
import api from "../../services/api";
import {
  CNPJField,
} from '../../components';
import { useScript } from '../../hooks/useScript';

yup.setLocale(pt);

//const sitekey = "6LeK1MceAAAAACM096lU71zJeznaIVqLuzuwvDE0";
const containerId = "recaptcha_id";
const recaptchaSize = "normal";

const isDevelopOrLocal = Boolean(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.includes('develop') ||
      window.location.hostname.includes('dev-') ||
      window.location.hostname.startsWith('dev.') ||
      window.location.hostname.includes('homolog') ||
      process.env.NODE_ENV === 'development' ||
      process.env.REACT_APP_ENV === 'develop' ||
      (process.env.REACT_APP_API_URL_BASE &&
        (process.env.REACT_APP_API_URL_BASE.includes('dev') ||
          process.env.REACT_APP_API_URL_BASE.includes('develop') ||
          process.env.REACT_APP_API_URL_BASE.includes('localhost'))))
);

const roles = [{
  id: 'fornecedor', name: 'Fornecedor'
}];


const InscFornecedor = () => {
  const setCnpjValidado = useStoreActions((actions) => actions.interesse.setCnpjValidado);
  const navigate = useNavigate();

  const [captchaResponse, setCaptchaResponse] = useState(null);
  const [captchaErrorMsg, setCaptchaErrorMsg] = useState(null);
  const [cnpjErrorMsg, setCnpjErrorMsg] = useState(null);

  const [linkEdital, setLinkEdital] = useState(null);
  const [openMensagem, setOpenMensagem] = useState(false);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);


  const onSubmit = async (data) => {
    if (!isDevelopOrLocal && !captchaResponse) {
      setCaptchaErrorMsg('Captcha inválido');
      return;
    }

    startLoading();
    try {
      await api.http.post('/fornecedores/interesses', {
        ...data,
        captchaToken: captchaResponse,
      });
      window._paq.push(["FormAnalytics::trackFormConversion", "potencializee"]);
      stopLoading();
      setOpenMensagem(true);
    } catch (error) {
      stopLoading({ message: error.toString(), severity: "error" });
    }
  };


  const defaultValues = {
    empresa: '',
    cnpj: '',
    email: ''
  };

  const schema = yup.object({
    empresa: yup.string().label('Empresa').required(),
    cnpj: yup.string().cnpj().label('CNPJ').required(),
    email: yup.string().email().label('Email').required(),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues: defaultValues
  });

  const {
    handleSubmit,
    formState: { errors },
  } = useFormRef;

  const successCallback = (response) => {
    setCaptchaResponse(response);
    setCaptchaErrorMsg(null);
  };

  const expiredCallback = () => {
    setCaptchaResponse(null);
  };

  const sitekey = process.env.REACT_APP_CAPTCHA_KEY;

  useRecaptcha({
    containerId,
    successCallback: (response) => {
      setCaptchaResponse(response);
      setCaptchaErrorMsg(null);
    },
    expiredCallback: () => {
      setCaptchaResponse(null);
    },
    sitekey,
    size: recaptchaSize,
    enabled: !isDevelopOrLocal,
  });

  const onOkMensagem = () => {
    navigate("/login", { replace: true });
  };


  const handleBlur = async (e) => {
    const cnpj = e.target.value.replace(/\D/g, '');

    if (cnpj) {
      try {
        const fornecedor = await api.http.get("/fornecedores/exists/cnpj/" + cnpj);

        if (fornecedor?.data?.existe) {
          setCnpjErrorMsg("Já existe um cadastro com este CNPJ.");
        } else {
          setCnpjErrorMsg(null);
        }
      } catch (error) {
        console.error('Erro ao buscar fornecedor:', error);
      }
    } else {
    }
  };


  return (
    <Container sx={{ mt: 3 }}>
      <Typography color="inherit" variant="h5">
        Preencha o formulário abaixo e participe!
      </Typography>

      <Paper variant="outlined" className='center-box' sx={{
        px: 4,
        pt: 2,
        pb: 3,
        mb: 7
      }}>
        <DialogoMensagem title="Sucesso" open={openMensagem} onOk={onOkMensagem}>
          Sua inscrição foi registrada com sucesso em nosso sistema. Em breve
          você receberá um e-mail para acessar e dar continuidade ao seu cadastro.
        </DialogoMensagem>
        <p>Inicie a participação de sua empresa como fornecedora de tecnologia</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              field="empresa"
              useFormRef={useFormRef} schema={schema} />
          </FormControl>

          <FormControl sx={{ my: 2 }} fullWidth>
            <CNPJField
              margin="dense"
              fullWidth
              field="cnpj"
              useFormRef={useFormRef}
              schema={schema}
              onBlur={handleBlur} />
          </FormControl>
          {cnpjErrorMsg && (
            <Box sx={{ my: 3 }}>
              <h3>{cnpjErrorMsg}</h3>
            </Box>
          )}
          <FormControl sx={{ my: 2 }} fullWidth>
            <TextField
              margin="dense"
              fullWidth
              field="email"
              type="email"
              useFormRef={useFormRef} schema={schema} />
          </FormControl>

        </form>
        {!isDevelopOrLocal && (
          <Box sx={{ my: 3 }}>
            <div id={containerId} />
            {captchaErrorMsg && <FormHelperText error={true}>{captchaErrorMsg}</FormHelperText>}
          </Box>
        )}
        <Button variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={handleSubmit(onSubmit)}
          disabled={false}>INSCREVER</Button>
        <br />
        <br />
        <p>
          O PotencializEE – Programa Investimentos Transformadores de Eficiência Energética na Indústria – tem o intuito de promover Eficiência Energética em PMEs (Pequenas e Médias Empresas) industriais. A implementação tem foco na região de São Paulo, considerando a maior concentração de indústrias e os altos índices de consumo de energia, e contará com estratégias a fim de alavancar os potenciais de Eficiência Energética na Indústria em nível nacional.
        </p>
        <p>
          A iniciativa é um Programa de Cooperação Brasil-Alemanha para o Desenvolvimento Sustentável, liderado pelo MME (Ministério de Minas e Energia) e coordenado por meio da GIZ (Deutsche Gesellschaft für Internationale Zusammenarbeit), Agência Alemã de Cooperação Internacional.
        </p>
      </Paper>
    </Container>
  );
};

function useRecaptcha({ containerId, successCallback, expiredCallback, sitekey, size, enabled = true }) {
  useScript(enabled ? "https://www.google.com/recaptcha/api.js?render=explicit" : null);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") return;
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.render(containerId, {
          sitekey,
          callback: successCallback,
          "expired-callback": expiredCallback,
          size,
        });
      });
    }
  }, [containerId, successCallback, expiredCallback, sitekey, size, enabled]);
}

export default InscFornecedor;
